var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0003 2.29199C5.74313 2.29199 2.29199 5.74313 2.29199 10.0003C2.29199 14.2575 5.74313 17.7087 10.0003 17.7087C13.864 17.7087 17.0647 14.8655 17.6225 11.1574C17.6738 10.816 17.9922 10.5809 18.3335 10.6323C18.6748 10.6836 18.9099 11.002 18.8586 11.3433C18.2102 15.6539 14.4917 18.9587 10.0003 18.9587C5.05277 18.9587 1.04199 14.9479 1.04199 10.0003C1.04199 5.05277 5.05277 1.04199 10.0003 1.04199C13.6748 1.04199 16.8312 3.25415 18.213 6.41676C18.3512 6.73307 18.2068 7.10151 17.8905 7.23971C17.5742 7.37791 17.2057 7.23353 17.0675 6.91722C15.8775 4.19348 13.1603 2.29199 10.0003 2.29199Z",
    fill: "#2E2E38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3337 1.87533C18.6788 1.87533 18.9587 2.15515 18.9587 2.50033V6.16699C18.9587 6.78831 18.455 7.29199 17.8337 7.29199H14.167C13.8218 7.29199 13.542 7.01217 13.542 6.66699C13.542 6.32181 13.8218 6.04199 14.167 6.04199H17.7087V2.50033C17.7087 2.15515 17.9885 1.87533 18.3337 1.87533Z",
    fill: "#2E2E38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.f5a8e881a186dfa6747960d2755a7e1a.svg";
export { ForwardRef as ReactComponent };